import Vue from "vue";
import firebase from "firebase";

import App from "./App.vue";
import router from "./router";
import store from "./store";

Vue.config.productionTip = false;

let app = "";

const firebaseConfig = {
  apiKey: "AIzaSyApxuD_ew3jXnuhQ-wHk8MkHV3ZGP3vKx8",
  authDomain: "gcdiy-3bf39.firebaseapp.com",
  databaseURL: "https://gcdiy-3bf39.firebaseio.com",
  projectId: "gcdiy-3bf39",
  storageBucket: "gcdiy-3bf39.appspot.com",
  messagingSenderId: "973760866383",
  appId: "1:973760866383:web:20a89adf92ea2c2a6da23a",
  measurementId: "G-FE09F1C0V2"
};

firebase.initializeApp(firebaseConfig);

firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount("#app");
  }
});
